<template>
  <div>
    <CRow>
      <CCol md="12">
        <CForm>
          <CCard>
            <CCardHeader class="p-1">
              <CRow>
                <CCol col="5" style="text-align: start ;padding:10px 20px 0 20px ">

                  <strong>افزودن کارتابل</strong>
                </CCol>
                <CCol col="2" style="text-align: start ;padding:10px 20px 0 20px ">



                </CCol>
                <CCol col="5" style="text-align: end">
                  <!--                                    <CButton v-if="status_form==0 " @click="insert_data_factor()" size="sm"-->
                  <!--                                             color="secondary">-->
                  <!--                                        {{ $t('preview') }}-->
                  <!--                                    </CButton>-->


                  <!--                                    <CButton v-if="status_form!=0" @click="insert_data_factor()" size="sm"-->
                  <!--                                             color="secondary">-->
                  <!--                                        <CIcon size="sm" name="cil-check-circle"/>-->
                  <!--                                        {{ $t('buttons.editDocument') }}-->
                  <!--                                    </CButton>-->
                  <CButton v-if="status_form==0 && !is_year_closed()" class="mr-1 ml-1" @click="insert_data_factor()"
                           size="sm"
                           color="secondary">
                    {{ $t('preview') }} F2
                  </CButton>

                  <CButton v-if="status_form==0  && is_year_closed()" class="mr-1 ml-1"
                           @click="year_closed_dialog()" type="submit"
                           size="sm" color="danger">
                    {{ $t('preview') }}
                  </CButton>

                  <CButton v-if="status_form!=0 && !is_year_closed()" @click="insert_data_factor()" size="sm"
                           color="secondary">
                    {{ $t('buttons.editDocument') }} F2
                  </CButton>
                  <CButton v-if="status_form!=0  && is_year_closed()" class="mr-1 ml-1"
                           @click="year_closed_dialog()" type="submit"
                           size="sm" color="danger">
                    {{ $t('buttons.editDocument') }}
                  </CButton>
                  <CButton
                      class="mr-1"
                      size="sm"
                      color="secondary"
                      @click="emptyList"
                  >{{ $t("buttons.cancel") }}
                  </CButton>

                  <a href="/dashboard/sale-orders/sale-invoice" target="_blank">
                    <CButton
                        class="mr-1 ml-1"
                        size="sm"
                        color="dark"
                    >
                      <CIcon size="sm" name="cil-plus"></CIcon>
                    </CButton>
                  </a>
                </CCol>
              </CRow>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol col="5">
                  <CRow form class="form-group">
                    <CCol tag="label" sm="3" class="col-form-label">
                      {{ $t('customer') }}
                    </CCol>
                    <CCol>
                      <treeselect
                          v-model="document_person"
                          :cacheOptions="false"
                          :async="async_person_search"
                          @select="select_person"
                          :options="async_person_options"
                          :load-options="load_persons"
                          :placeholder="$t('search')"
                          :normalizer="normalizer_persons"
                      />
                      <div style="display: flex;justify-content: space-between;">
                        <label>
                          {{ $t('tables.balance') }}:
                          {{ get_currency(document_person_remain_amount) }}
                        </label>
                        <label v-if="document_person_credit!=null">
                          {{ $t('credit') }}:
                          {{ get_currency(document_person_credit) }}
                        </label>
                      </div>

                    </CCol>
                    <CCol col="1" >

                      <CButton
                          v-if="document_person==null"
                          @click="open_new_customer()"
                          color="dark" size="sm">

                        <CIcon name="cil-plus"
                               size="sm"/>
                      </CButton>
                    </CCol>
                    <CCol col="1" class="m-0">
                      <CButton
                          v-if="document_person!=null"

                          :href="'/dashboard/sale-orders/edit-customer/'+document_person"
                          target="_blank" color="dark" size="sm">
                        <CIcon size="sm" name="cil-user"/>
                      </CButton>
                    </CCol>
                  </CRow>
                </CCol>

                <CCol col="6" >
                </CCol>
                <CCol col="3" >
                  <CSelect
                      :options="category_items"
                      label="دسته بندی"
                      :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                      :value.sync="selected_category"
                  />
                </CCol>
                <CCol col="3" >
                  <CSelect
                      :options="brand_items"
                      label="برند"
                      :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                      :value.sync="selected_brand"
                  />
                </CCol>
                <CCol col="3" >
                  <CInput
                      label="مدل"
                      :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"
                      v-model="device_model"
                  />
                </CCol>

                <CCol col="3" >
                  <CInput
                      label="سریال دستگاه"
                      :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"
                      v-model="device_serial"
                  />
                </CCol>
                <CCol col="3" >
                  <CInput
                      label="قفسه دستگاه"
                      :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"
                      v-model="device_wharehouse_location"
                  />
                </CCol>
                <CCol col="3" >
                  <CTextarea
                      label="توضیحات مشتری"
                      :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"
                      v-model="device_user_description"
                  />
                </CCol>
                <CCol col="3" >
                  <CTextarea
                      label="توضیحات تکنسین"
                      :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"
                      v-model="device_tech_description"
                  />
                </CCol>
                <CCol col="3" >
                  <CTextarea
                      label="توضیحات مخفی تکنسین"
                      :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"
                      v-model="device_tech_hidden_description"
                  />
                </CCol>
                <CCol col="3" >
                  <CTextarea
                      label="لوازم همراه"
                      :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"
                      v-model="device_additional_devices"
                  />
                </CCol>

              </CRow>


              <div style="min-height: 250px" class="overflow-auto">

              </div>


            </CCardBody>

          </CCard>
        </CForm>

      </CCol>
    </CRow>
    <CModal
        title="افزودن مشتری"
        size="sm"
        :closeOnBackdrop=true
        :show.sync="new_customer_modal"
    >
      <CRow>
        <CCol>
          <CInput v-model="new_customer_mobile"
                  :label="$t('mobile')"/>
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          <CInput v-model="new_customer_name"
                  :label="$t('name')"/>
        </CCol>
      </CRow>

      <template #footer>
        <CButton @click="new_customer_modal=false" color="danger">{{ $t('buttons.cancel') }}</CButton>
        <CButton @click="add_new_customer()" color="success">{{ $t('buttons.ok') }}</CButton>
      </template>
    </CModal>


    <!--    <div style="display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;margin-bottom: 36px"-->
    <!--         v-if="get_access('super_market_config')">-->
    <!--      <div @click="add_w_barcode_to_factor(pro)" style="width: 10%;" v-for="(pro,index) in products_w_barcode"-->
    <!--           :key="'wb-'+index">-->
    <!--        <div style="margin:1px;height:35px;border: 1px solid grey;border-radius: 3px">{{ pro.productName }}</div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
// import Vue from "vue";
import Vue from 'vue'
import 'vue-context/src/sass/vue-context.scss';

import VueContext from 'vue-context';
import moment from 'moment-jalaali'

import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

var simulateAsync = null
const simulateAsyncOperation = fn => {
  if (simulateAsync != null) {
    clearTimeout(simulateAsync)
  }
  simulateAsync = setTimeout(fn, 1000)
}


export default {
  name: 'Login',
  components: {
    Treeselect,
    VueContext,
  }, props: {
    selectedType: Number
  },

  data() {
    return {
      categories: [],
      category_items: [],
      selected_category: null,

      brand_items: [],
      selected_brand: null,

      device_model:'',
      device_serial:'',
      device_user_description:'',
      device_tech_description:'',
      device_tech_hidden_description:'',
      device_wharehouse_location:'',
      device_additional_devices:'',

      last_row_updated: -1,
      key_handler: null,
      document_person_credit: '',
      cashier_payment: '',
      pos_pay: '',
      new_customer_name: '',
      new_customer_mobile: '',
      products_w_barcode: [],
      new_customer_modal: false,
      fyear_min_date: localStorage.getItem('fyear_min_date'),
      fyear_max_date: localStorage.getItem('fyear_max_date'),
      async_person_search: true,
      async_person_options: [],
      off_over_nesie: '0',
      total_factor_off_type: 2,
      total_factor_off: '',
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      product_index_clicked: 0,
      customer_doc_name: '',
      VUE_APP_Currency: localStorage.getItem('currency'),
      VUE_APP_Weight: localStorage.getItem('weight'),

      document_result_price: [],
      date: '',


      selectedTypeQty: -1,
      selectedTypeLabel: this.$t('components.customer'),

      document_person: null,
      document_person_name: "",
      document_person_method_name: "",
      document_person_remain_amount: "0",
      document_summary: '',

      barcode_model: '',
      purchase_price: '0',
      product_name: '',
      product_catrel: 0,
      product_non_off: false,
      product_existance: '',
      product_count: '',
      product_unit: '',
      product_unit_name: '',
      product_unit_value: '',
      product_weight: '',
      product_summary: '',
      product_price: '',
      product_off: '',
      product_tax: '',
      product_off_is_percent: '',
      text_input_searcher: null,
      pay_type_items: [],
      selected_pay_type: 0,
      total_price: 0,
      total_weight: 0,
      details: [],
      cashiers: [],
      selected_cashiers: 0,
      selected_cashiers_pos: 0,
      permission_group_items: [],
      selected_permission_group: 0,
      document_visitor: null,
      async_visitor_search: true,
      async_visitor_options: [],
      unit_items: [],
      unit_items_filtered: [],
      selected_place: 0,
      places_items: [],

      selected_product: null,
      status_product_form: -1,
      status_form: 0,
      master_id: 0,
      normalizer_products(node) {
        return {
          id: node.id,
          label: node.productCodeName,

        }
      },

      load_persons({action, searchQuery, callback}) {
        var self = this;
        if (action === ASYNC_SEARCH && searchQuery.length >= 3) {

          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);
            var url = "GetAllPersons";

            formData.append('IsVendor', false);
            formData.append('IsWorker', false);
            formData.append('IsCustomer', true);
            formData.append('IsActive', 0);

            axios.post(url, formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

            })
                .catch(function (error) {

                  console.log(error);
                });
          })
        }
      },
      load_visitors({action, searchQuery, callback}) {
        var self = this;
        if (action === ASYNC_SEARCH && searchQuery.length >= 3) {

          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);
            var url = "GetAllPersons";

            formData.append('IsVendor', false);
            formData.append('IsWorker', true);
            formData.append('IsCustomer', false);
            formData.append('IsActive', 0);

            axios.post(url, formData, {show_pros: true}).then(function (response) {
              options = response.data.data;
              callback(null, options);
            })
                .catch(function (error) {
                  console.log(error);
                });


          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,

        }
      },

    }
  },
  computed: {

    data_units() {
      var units_data = [];
      this.unit_items_filtered.forEach((val) => {
        var obj = {label: val.unitName, value: val.id}
        units_data.push(obj);
      });
      return units_data;
    },

  },
  created() {
    var self = this
    this.key_handler = function (e) {
      if (e.code == "F2") {
        self.insert_data_factor();
      }
      if (e.code == "Delete") {
        if (self.status_form == 0 && self.last_row_updated > 0) {
          self.product_items.splice(self.last_row_updated, 1);
        }

      }
      if (e.code == "Insert") {
        if (self.status_form == 0 && self.last_row_updated > 0) {
          self.edit_item(self.product_items[self.last_row_updated].product_id)
        }
      }

    }
    window.addEventListener('keyup', this.key_handler);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.key_handler);
  },
  mounted() {

    // console.log(document.getElementById("product_seeker").children[0].children[0].children[1].children[0]);
    // this.selectedType = this.$route.params.type_id
    this.$root.root_validate_errors = [];
    this.date = this.get_today();
    if (new Date(this.date) > new Date(this.fyear_max_date)) {
      this.date = this.fyear_max_date
    }
    bus.$on('close_add_base_modal', (data) => {
      this.get_base_data();
    });
    this.get_base_data();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {

      } else {
        // this.cancel_edit_product()

        this.status_product_form = -1;
      }
    });
    bus.$on('update_price', (data) => {
      // alert(data);
      if (data == "true") {
        this.$router.push({path: "/dashboard/products/edit-price/" + this.added_product});

      } else {
        this.status_form = 0;
      }
    });

    if (this.$route.params.user_id != null) {
      this.status_form = this.$route.params.user_id;
      this.get_user_data();
    }

    if (this.$route.params.edit_doc_id != null) {
      this.status_form = this.$route.params.edit_doc_id;
      this.get_document_master();
    }

  },
  watch: {
    'last_row_updated': function () {
      const self = this
      setTimeout(function () {
        const element_index = document.getElementById("sale_table").children[0].children[0].children[1].children[self.last_row_updated - 1]
        document.getElementById("sale_table").children[0].scrollTo(0, element_index.offsetTop - element_index.offsetHeight)

      }, 500)
    },
    'new_customer_mobile': function () {
      this.new_customer_name = this.new_customer_mobile
    },


    'document_person': function () {
      if (this.document_person != null) {
        this.get_user_data();
        this.get_person_remaining_amount()
      }

    },


  },
  methods: {
open_new_customer(){
  window.open('/dashboard/sale-orders/add-customer')
},

    load_products({action, searchQuery, callback}) {

      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          const formData = new FormData();

          formData.append('SearchTxt', searchQuery);
          if (this.document_person != null) {
            formData.append('PersonId', this.document_person);
          }

          axios.post('GetProducts', formData, {show_pros: true}).then(function (response) {
            callback(null, response.data.data);
            // callback(null, []);
            response = null
          })
              .catch(function (error) {
                console.log(error);
              });

        })
      }
    },

    select_person(node) {
      var valid = true;
      console.log("node vperson is ", node.isBlackList, node.pStatusId);
      if (node.isBlackList == 39) {
        this.$root.root_validate_errors.push(this.$t('isInBlacklist'));
        valid = false;
      }
      if (node.pStatusId == 40) {
        this.$root.root_validate_errors.push(this.$t('isDectivated'));
        valid = false;

      }
      var self = this;

      if (!valid) {
        setTimeout(function () {
          self.document_person = null;
        }, 200);
      }
    },


    another_focus(id) {
      setTimeout(function () {
        document.getElementById(id).focus()
        document.getElementById(id).select()

      }, 200);
    },
    get_person_remaining_amount() {
      var self = this;
      const formData = new FormData();

      formData.append('FromDate', moment().locale('en').format('YYYY-MM-DD'));
      formData.append('ToDate', moment().locale('en').format('YYYY-MM-DD'));
      var url = ""
      url = "GetLastPartyAccountByParam"

      formData.append('TafsiliType', 2);


      formData.append('id', 0);

      formData.append('PartyId', this.document_person);
      formData.append('ParentId', 10);
      formData.append('ChildId', 10);
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.document_person_remain_amount = response.data.data.balance


          // response.data.data.balance
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }
      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_base_data() {
      this.get_categories();
      this.get_brands();
      this.get_default_customer();
    },
    get_brands() {
      var self = this;
      this.$apis.get_brands(this.$t('noBrand')).then(result => {
        self.brand_items = result
      })
    },
    get_categories() {
      var self = this;

      const formData = new FormData();
      formData.append('id', 0);
      axios.post('GetAllCats', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.categories = content_data.data

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });
      this.$apis.get_cats().then(result => {
        self.category_items = result

      })
    },

    get_default_customer() {
      var self = this;

      const formData = new FormData();

      axios.post('GetDefaultCustomer', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.data != null) {
          content_data.data.userId = content_data.data.personId;
          content_data.data.userName = content_data.data.personName;
          self.document_person = content_data.data.personId;

          // id: node.userId,
          //     label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,

          self.async_person_search = false;
          self.async_person_options = [content_data.data]
          setTimeout(function () {
            self.async_person_search = true;

          }, 300)

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    add_new_customer() {
      var self = this;

      const formData = new FormData();

      var person = {
        "Person": {
          "Title": 1,
          "PersonId": 0,
          "MiddelName": "",
          "SurName": "",
          "PersonTitle": "",
          "PersonName": this.new_customer_name,
          "PersonCode": "",
          "NationalCode": "",
          "MobileNo": "",
          "PhoneNo": "",
          "IsWorker": false,
          "IsCustomer": true,
          "IsVendor": false,
          "GuildUnitTitleId": 1002,
          "Porsant": "0",
          "PStatus": 39,
          "IsBlackList": 40
        },
        "PersonAddress": [{
          "CountryId": 1,
          "ProvinceId": 7,
          "CityId": 770,
          "RegionId": 2076,
          "postCode": "",
          "AreaRelId": 0,
          "AddressText": "تهران",
          "Lat": 0,
          "Lng": 0
        }, {
          "CountryId": 1,
          "ProvinceId": 0,
          "CityId": 0,
          "RegionId": 0,
          "postCode": "",
          "PhoneNo": "",
          "AreaRelId": 0,
          "AddressText": "",
          "Lat": 0,
          "Lng": 0
        }],
        "PersonContacts": [{"ContactType": 19, "Contact": this.new_customer_mobile}, {
          "ContactType": 18,
          "Contact": ""
        }, {"ContactType": 63, "Contact": ""}],
        "UserDepartemans": [],
        "PersonExtraInfo": {
          "Gender": 4,
          "PersonTypeId": 37,
          "BirthData": "",
          "BimeNumber": 0,
          "MaritalStatus": 7,
          "Citizenship": "",
          "CategoryId": 0,
          "EconomicCode": "",
          "CompanyCode": "",
          "Assessment": 61,
          "OtherLanguage": "",
          "Education": 48,
          "Skills": "",
          "ResidentialStatus": 9,
          "NationalCode": ""
        },
        "PersonBankInfo": {"BankId": 6, "AccountName": "", "AccountNo": 0, "SortCode": 0, "Iban": 0},
        "PersonEmrgencyContact": {
          "Name": "",
          "SurName": "",
          "Relationship": 41,
          "Mobile": "",
          "TrainingCourses": "",
          "DisabilityStatus": ""
        },
        "PersonJobProfile": {
          "EmploymentDate": "",
          "ContractNumber": 0,
          "CooperationType": 11,
          "LeaversDate": "",
          "ReasonsForLeaving": "",
          "Benefit": "",
          "PensionStartDate": "",
          "wage": 0,
          "shift": 29,
          "hours": "",
          "paymentFrequency": 0,
          "Credit": "",
          "SaleType": 0,
          "paymentMethod": 58
        },
        "PeopleInfos": [],
        "UserGroup": {"GroupRecId": 0}
      }
      // formData.append('PersonModule', JSON.stringify(person));
      formData.append('username', this.new_customer_mobile);
      formData.append('mobileNo', this.new_customer_mobile);

      axios.post('AddCustomerNew', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.data != null) {
          content_data.data.userId = content_data.data.id;
          content_data.data.userName = self.new_customer_name;
          content_data.data.mobileNo = self.new_customer_mobile;
          content_data.data.personCode = "";
          content_data.data.surName = "";
          self.document_person = content_data.data.userId;

          // id: node.userId,
          //     label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,

          self.new_customer_modal = false;
          self.async_person_search = false;
          self.async_person_options = [content_data.data]
          setTimeout(function () {
            self.async_person_search = true;

          }, 300)

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },

    go_to_add_modal(func) {
      bus.$emit("show_add_base_modal", func);
    },

    validateForm: function () {
      this.$root.root_validate_errors = [];


      if (this.date != ''  && this.document_person != null) {
        return true;


      }

      if (this.date == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertDate'));
      }
      if (this.selected_place == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectWarehouse'));
      }
      if (this.document_person == null) {
        this.$root.root_validate_errors.push(this.selectedTypeLabel + this.$t('dialogs.select'));
      }
      if (this.status_form!=0 && this.product_items.length <= 1) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectProducts'));
        return false
      }

      return false;
      // e.preventDefault();
    },

    emptyList() {
      // this.$router.push({path: '/dashboard/products/list'})
      // this.$forceUpdate();
      bus.$emit('reload_invoice_component', true);
    },

    get_user_data() {

      let self = this;
      const formData = new FormData();
      let url;
      url = "GetPersonById";

      formData.append('id', this.document_person);


      axios.post(url, formData, {}).then((res) => {

        if (res.data.data.personJobProfile.paymentMethod == 58 && self.status_form == 0) {
          self.selected_pay_type = 34;
        }
        if (res.data.data.personJobProfile.paymentMethod == 59 && self.status_form == 0) {
          self.selected_pay_type = 35;
        }
        self.document_person_method_name = res.data.data.methodName;
        self.document_person_credit = res.data.data.personJobProfile.credit;


      })
          .catch(function (error) {

            console.log(error);
          });


    },

    insert_data_factor() {
      console.log('insert_data_factor called')
      if (!this.validateForm()) {
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;

        url = "AddEditSeviceReq";

      formData.append('requestId', this.status_form)

      // if (this.get_access('super_market_config')) {
      //   this.insert_supermarket_factor()
      //   return false
      // }
      // PayType
      //
      var json_cost = [];
      if (this.delivery_cost_amount != '' && this.delivery_cost_amount != '0') {
        json_cost.push({DeliveryCostId: 1, DeliveryCostPrice: this.delivery_cost_amount});
      }
      if (this.sec_cost_amount != '' && this.sec_cost_amount != '0') {
        json_cost.push({DeliveryCostId: this.selected_sec_cost, DeliveryCostPrice: this.sec_cost_amount});
      }
var generated_name = "تعمیر ";
      generated_name+=this.category_items.filter(x=>x.value==this.selected_category)[0].label
      generated_name+=" "
      generated_name+=this.brand_items.filter(x=>x.value==this.selected_brand)[0].label
      generated_name+=" "
      generated_name+=this.device_model
      formData.append('requestName',generated_name);
      formData.append('catRelId', this.selected_category);
      formData.append('brandId', this.selected_brand);
      formData.append('modelNo', this.device_model);
      formData.append('serialNo', this.device_serial);
      formData.append('reqDesc', this.device_user_description);
      formData.append('techDesc', this.device_tech_description);
      formData.append('extraInfo', this.device_additional_devices);
      formData.append('device_wharehouse_location', this.device_wharehouse_location);
      formData.append('device_tech_hidden_description', this.device_tech_hidden_description);

      formData.append('DocDate', this.date);
      formData.append('ownerId', this.document_person);


      axios.post(url, formData, {}).then((res) => {

        // self.get_lists();
        self.$root.modal_component.show_api_response_modals(res);
        if (this.status_form == 0) {

          self.master_id = res.data.data.requestId;
          // self.insert_factor_products();
          self.$router.push({path: "/dashboard/sale-cartable/show/" + self.master_id})

          // self.product_items.forEach((val) => {
          //     self.insert_factor_products(index);
          //     index+=1;
          //
          // });

        } else {
          self.$router.push({path: "/dashboard/documents/show/" + self.status_form})

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },

    get_document_master() {
      var self = this;
      console.log("route id " + this.$route.params.edit_doc_id);

      const formData = new FormData();

      var url = "GetRecById";

      formData.append("id", this.$route.params.edit_doc_id);

      axios.post(url, formData, {}).then(function (response) {
        console.log("cats is " + response.data);

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
//     self.items_buy = content_data.data.map((item, row_id) => {
// // if(item.isCustomer){
//     return {...item, row_id}
          self.selectedType = content_data.data.docType;
          self.document_person_name = content_data.data.partyName;
          self.document_person = content_data.data.partyId;
          self.total_factor_off_type = content_data.data.factorDiscountType;
          self.total_factor_off = content_data.data.factorDiscount;
          if (self.total_factor_off == '0') {
            self.total_factor_off = '';
          }

          self.async_person_search = false;
          self.async_person_options = [{
            personCode: '',
            surName: '',
            mobileNo: '',
            userId: self.document_person,
            userName: self.document_person_name
          }]
          setTimeout(() => {
            // this.result.push(event.type);
            self.async_person_search = true;
          }, 1500);


          self.date = content_data.data.docDate.replace("-", "/").replace("-", "/");
          self.selected_place = content_data.data.placeId;
          self.document_summary = content_data.data.docDesc;
          if (self.document_summary == null || self.document_summary == 'null') {
            self.document_summary = "";
          }
          //async visitor
          self.async_visitor_search = false
          self.document_visitor = content_data.data.salesManId;
          self.async_visitor_options = [{
            userId: content_data.data.salesManId,
            personCode: content_data.data.salesManTitle,
            userName: '',
            middelName: '',
            surName: '',
            mobileNo: '',
          }]
          setTimeout(function () {
            self.async_visitor_options = true;

          }, 300)
//end async visitor

          self.document_driver = content_data.data.toziKonande;
          self.doc_status = content_data.data.statusId;
          self.tablo = content_data.data.tablo;
          self.address = content_data.data.addressText;
          self.vMobile = content_data.data.vMobile;
          self.partyMobile = content_data.data.partyMobile;
          self.tozikonandeMobile = content_data.data.tozikonandeMobile;
          if (content_data.data.isReorder != null && content_data.data.isReorder != 0) {
            self.document_person = null;
            self.status_form = 0;
          }
          // self.reorder = content_data.data.isReorder;

          for (var i = 0; i < content_data.data.deliveryCostItems.length; i++) {
            if (content_data.data.deliveryCostItems[i].deliveryCostId == 1) {
              self.delivery_cost_amount = content_data.data.deliveryCostItems[i].deliveryCostPrice;
            } else {
              self.selected_sec_cost = content_data.data.deliveryCostItems[i].deliveryCostId
              self.sec_cost_amount = content_data.data.deliveryCostItems[i].deliveryCostPrice;
            }

          }

          self.selected_pay_type = parseInt(content_data.data.payType);

          self.selectedType = content_data.data.docType;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

  }
}

</script>
<style>
.bg-secondary-input input {
  background: #ced2d8 !important;
  color: white;
}
</style>
